
import {defineComponent, PropType} from 'vue'
import { CtStockItem } from '@/models/interfaces/content-type'

export default defineComponent({
  name: 'ProductCardComponent',
  props: {
    id: {
      type: String,
    },
    count: {
      type: String,
    },
    component: {
      type: Object as PropType<Partial<CtStockItem>>,
    }
  },

  setup (props) {
    return {}
  }
})
